import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  countriesSelection: [],
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    getCountriesSelection: (state, action) => {
      state.countriesSelection = action.payload;
    },
    resetCountriesSelection: state => {
      state.countriesSelection = initialState.countriesSelection;
    },
  },
});

export const { getCountriesSelection, resetCountriesSelection } = configSlice.actions;

export default configSlice.reducer;
